// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6fe0ebb8","738":"dc9b7d09","949":"4665b8ae"}[chunkId] + ".chunk.js";
};